import { Notification } from '../../../store/modules/notifications'

export class NotificationItemVm {
  constructor(private notification: Notification) {}

  get avatarInitials() {
    return this.notification.author?.initials
  }

  get avatarUrl() {
    return this.notification.author?.avatarUrl
  }

  get notificationType() {
    return this.notification.notificationType
  }

  get showUnreadIndicator() {
    return !this.notification.read
  }

  get showAvatar() {
    return this.notification.author !== null
  }

  get avatarAltText() {
    if (!this.notification.author) return

    return `Avatar for ${this.notification.author.fullName}`
  }
}
